<div id="search-component">
    <span class="badge">Search</span>
    <input class="form-control" type="text" placeholder="Search routes, stations, or stops..." #searchBox id="search-box" (input)="search(searchBox.value)" />

    <ul class="list-group mt-2 mb-3">
      <li class="list-group-item" *ngFor="let result of routes$ | async" >
        <a routerLink="/routes/status/{{result.route}}">
          {{ result.route_name }}
        </a>
        <div>
          <span class="badge">Route</span>
        </div>
      </li>
      <li class="list-group-item" *ngFor="let result of results$ | async" >
        <a routerLink="/stop/rail/{{result.StopName}}/{{result.StopID}}">
          {{ result.StopName }}
        </a>
        <div>
          <span class="badge">Station</span>
        </div>
      </li>
      <li class="list-group-item" *ngFor="let result of stops$ | async" >
        <a routerLink="/stop/transit/{{result.StopName}}/{{result.StopID}}">
          {{ result.StopName }}
        </a>
        <div>
          <span class="badge">Stop</span>
        </div>
      </li>
    </ul>
</div>
